import React from 'react'

import { useAllDeliveryForecastDespatchAdviceItems } from '../../data'
import { ArticleDetailFormData } from './ArticleDetailForm'
import { ConfirmationBatchesTableData } from './ConfirmationBatchesTable'

type Props = {
  despatchAdviceId: string
}
export const ArticleDetail: React.FC<Props> = ({ despatchAdviceId }) => {
  const { data: items, isLoading } =
    useAllDeliveryForecastDespatchAdviceItems(despatchAdviceId)

  return (
    <>
      {items?.map(item => (
        <ArticleDetailFormData
          key={item.Id}
          despatchAdviceId={despatchAdviceId}
          item={item}
          items={items}
          isLoading={isLoading}
        >
          <ConfirmationBatchesTableData
            key={item.Id}
            despatchAdviceId={despatchAdviceId}
            itemId={item.Id}
            item={item}
            items={items}
            isLoading={isLoading}
          />
        </ArticleDetailFormData>
      ))}
    </>
  )
}
